export const menu = {
  menu_title: 'Resonance',
  // Header slot actions (ResonanceLayout)
  header_menu_aria: 'Menu',
  header_island_settings_aria: 'Island settings',
  header_call_aria: 'Call {{number}}',
  menu_logOut: 'Log Out',
  menu_language_button_text: 'Change',
  menu_languages_modal_title: 'Choose your language',
  menu_questionnaires_modal_title: 'Choose a questionnaire',
  menu_share_title: '{{appName}}',
  menu_share_text: 'Discover {{appName}} 🙂',
  menu_share_link_copied: '{{appName}} invitation link copied to the clipboard ✅',
  menu_share_not_supported: 'Sharing is not supported on this device.',
  menu_share_link_error: 'Unable to generate an invitation link right now.',
  menu_share_no_public_link: 'No public invitation link is configured.',
};
